module.exports = __webpack_public_path__ + "static/img_pledge_children_01-d899692c62506f4643ec92addb131553.png";